import * as defaultImport from "@splunk/moment";
export * from "@splunk/moment";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
